import React, { useEffect, useState } from "react"
import { ScrollView, View } from "react-native";
import { activtyDataSubscription } from "../../utils/services/subject-behaviour/CommonRxjsService";

import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { ActivityViewDesign } from "../../utils/widgets/ActivityViewDesign";

import { ActivityType } from "../../utils/constants/AppConstants";

import AppTheme from "../../AppTheme";

const ActivityList = (props) => {

    const [activityList, setActivityList] = useState([])

    useEffect(() => {
        activtyDataSubscription.getActiviytData().
            subscribe((updatedActivityData: any) => {
                if (updatedActivityData) {
                    if (updatedActivityData.activityList)
                        setActivityList(updatedActivityData.activityList)
                }
            })
    }, [])

    return <View style={{ width: AppTheme.appWidth }}>

        <CommonHeader navigation={props.navigation} title='Activity' />

        <ScrollView style={[{
            backgroundColor: AppTheme.color.background,
            marginTop: AppTheme.headerHeight, paddingBottom: 16,
            minHeight: AppTheme.appHeight - AppTheme.headerHeight
        }]}>{
                activityList.length > 0 && activityList.map((activity: any, i) => {
                    return <ActivityViewDesign activityData={activity}
                        navigation={props.navigation}
                        key={activity['acType'] == ActivityType.order ? activity['oid'] : activity['id']} />
                })
            }

        </ScrollView>
    </View>
}

export default ActivityList;